<div
  class="w-5 h-5 text-[10px] flex items-center justify-center rounded-full font-bold leading-0"
  [ngClass]="[config().class, config().textClass]"
>
  <span class="block">{{ config().letter }}</span>
</div>
